document.addEventListener('DOMContentLoaded', () => {
    const rewardStatus = localStorage.getItem('rewardStatus');

    if (rewardStatus) {
        localStorage.removeItem('rewardStatus');

        if (rewardStatus === 'success') {
            showRewardModal(
                'おめでとうございます！',
                '特典の付与が完了しました。'
            );
            console.log('Reward Applied...');
        }
        //  else {
        //     showRewardModal(
        //         '😔 申し訳ございません',
        //         'おっと！お客様は今回のキャンペーンの対象外のようです。'
        //     );
        //     console.log('Reward not applied');
        // }
    }
});
function showRewardModal(title, message) {
    const modal = document.createElement('div');
    modal.innerHTML = `
        <div class="reward-modal-overlay">
            <div class="reward-modal">
                <button id="reward-modal-close" class="reward-modal-close">
                    &times;
                </button>

                <div class="reward-modal-content">
                    <h2>${title}</h2>
                    <p>${message}</p>
                </div>
            </div>
        </div>
    `;

    document.body.appendChild(modal);

    document.getElementById('reward-modal-close').addEventListener('click', () => {
        modal.remove();
    });
}